// extracted by mini-css-extract-plugin
export default {"container":"GV-z","title":"HV-z","link":"IV-z"};